import { useRef } from "react";
import {
  TbArrowBackUp,
  TbArrowForwardUp,
  TbBold,
  TbItalic,
  TbPhotoUp,
  TbUnderline,
} from "react-icons/tb";
import { uploadAndInsert } from "./Editor";
import { ToolbarButton, ToolbarContainer, ToolbarDivider } from "./styled";
import { Caption1 } from "../../styles/typography";

const Toolbar = ({ editor }) => {
  const fileInputRef = useRef(null);

  if (!editor) return null;

  const handleFileChange = (e) => {
    const files = e.target.files;
    if (!files?.length) return;
    uploadAndInsert(editor, files);
    e.target.value = "";
  };

  const handleImageClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <ToolbarContainer>
      <div style={{ display: "inline-flex", gap: 4, alignItems: "center" }}>
        <ToolbarButton
          type="button"
          title="Bold"
          $active={editor.isActive("bold")}
          onClick={() => editor.chain().focus().toggleBold().run()}
        >
          <TbBold size={18} />
        </ToolbarButton>
        <ToolbarButton
          type="button"
          title="Italic"
          $active={editor.isActive("italic")}
          onClick={() => editor.chain().focus().toggleItalic().run()}
        >
          <TbItalic size={18} />
        </ToolbarButton>
        <ToolbarButton
          type="button"
          title="Underline"
          $active={editor.isActive("underline")}
          onClick={() => editor.chain().focus().toggleUnderline().run()}
        >
          <TbUnderline size={18} />
        </ToolbarButton>
        <ToolbarDivider />
        <ToolbarButton
          type="button"
          title="Upload image"
          $active={false}
          onClick={handleImageClick}
        >
          <TbPhotoUp size={18} />
          <Caption1>Upload image</Caption1>
        </ToolbarButton>
        <input
          ref={fileInputRef}
          type="file"
          multiple
          accept="image/png,image/jpeg,image/jpg"
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
      </div>
      <div style={{ display: "inline-flex", gap: 4, alignItems: "center" }}>
        <ToolbarButton
          type="button"
          title="Undo"
          $active={false}
          disabled={!editor.can().undo()}
          onClick={() => editor.chain().focus().undo().run()}
        >
          <TbArrowBackUp size={18} />
          <Caption1>Undo</Caption1>
        </ToolbarButton>
        <ToolbarButton
          type="button"
          title="Redo"
          $active={false}
          disabled={!editor.can().redo()}
          onClick={() => editor.chain().focus().redo().run()}
        >
          <TbArrowForwardUp size={18} />
          <Caption1>Redo</Caption1>
        </ToolbarButton>
      </div>
    </ToolbarContainer>
  );
};

export default Toolbar;
